export default {
  getClinicalUsers: state => state.clinicalUsers,
  getSupervisors: state => state.supervisors,
  getSupervisorsLoading: state => state.supervisorsLoading
}
